type ScrollingVideoProps = {
  style?: React.CSSProperties;
  videos: {
    mp4Src: string;
    webmSrc: string;
    style?: React.CSSProperties;
    alt: string;
  }[];
};

const scrollStyle = {
  position: "fixed" as const,
  top: "-200vh",
  left: 0,
  width: "100%",
  height: "300vh",
  zIndex: 1,
  animation: "scrollDown 20s linear infinite",
};

const videoStyle = {
  width: "100vw",
  height: "100vh",
  objectFit: "cover" as const,
  opacity: 0.6,
  display: "block",
};

export const ScrollingVideo = ({ style, videos }: ScrollingVideoProps) => {
  return (
    <div style={{ ...style, ...scrollStyle }}>
      {videos.map((video, index) => {
        return (
          <video
            key={index}
            autoPlay
            loop
            muted
            playsInline
            style={{ ...video.style, ...videoStyle }}
            aria-label={video.alt}
          >
            <source src={video.webmSrc} type="video/webm" />
            <source src={video.mp4Src} type="video/mp4" />
          </video>
        );
      })}
    </div>
  );
};
